export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10045.f9de8ffa.jpg";